<template>
  <div class="mask" @click="closeMask" @mousewheel.prevent="changePicSize">
    <img :src="imgSrc" :style="getImgSize" ref="img" alt="" />
  </div>
</template>

<script>
/* 放大图片组件 */
export default {
  name: 'pic-mask',
  props: {
    imgSrc: String,
    imgDeg: Number
  },
  data () {
    return {
      imgSize: 1
    }
  },
  computed: {
    getImgSize () {
      return (
        'transform:scale(' +
        this.imgSize +
        ');transform:rotateZ(' +
        this.imgDeg +
        'deg);'
      )
    }
  },
  methods: {
    closeMask () {
      this.$emit('closePicMask')
    },
    changePicSize (e) {
      if (e.deltaY > 0 && this.imgSize < 2) {
        this.imgSize += 0.05
      } else if (e.deltaY < 0 && this.imgSize > 0.5) {
        this.imgSize -= 0.05
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pic-mask.vue